// database.manager.ts
export class PostsDatabaseManager {
    private static instance: PostsDatabaseManager;
    private dbName = 'PostsCache';
    private dbVersion = 3;
    private db: IDBDatabase | null = null;

    static getInstance(): PostsDatabaseManager {
        if (!PostsDatabaseManager.instance) {
            PostsDatabaseManager.instance = new PostsDatabaseManager();
        }
        return PostsDatabaseManager.instance;
    }

    async initDB(): Promise<IDBDatabase> {
        return new Promise((resolve, reject) => {
            if (typeof window === 'undefined' || !window.indexedDB) {
                reject(new Error('IndexedDB not available'));
                return;
            }

            const request = indexedDB.open(this.dbName, this.dbVersion);

            request.onerror = () => reject(request.error);
            
            request.onsuccess = () => {
                this.db = request.result;
                resolve(this.db);
            };

            request.onupgradeneeded = (event) => {
                const db = (event.target as IDBOpenDBRequest).result;
                this.createStores(db);
            };
        });
    }

    private createStores(db: IDBDatabase) {
        // Create posts store
        if (!db.objectStoreNames.contains('posts')) {
            const store = db.createObjectStore('posts', { keyPath: '_id' });
            store.createIndex('modifiedOn', 'modifiedOn', { unique: false });
            store.createIndex('storageTime', 'storageTime', { unique: false });
            store.createIndex('filterContext', 'filterContext', { unique: false });
            store.createIndex('pageNumber', 'pageNumber', { unique: false });
        }

        // Create newPosts store
        if (!db.objectStoreNames.contains('newPosts')) {
            const newPostsStore = db.createObjectStore('newPosts', { keyPath: '_id' });
            newPostsStore.createIndex('modifiedOn', 'modifiedOn', { unique: false });
            newPostsStore.createIndex('storageTime', 'storageTime', { unique: false });
        }
    }

    getDB(): IDBDatabase | null {
        return this.db;
    }
}